import { accountDashboardLayoutRoute } from "../../../App";
import { createRoute } from "@tanstack/react-router";
import { Datasets } from "./Datasets";

export const accountDatasetsListRoute = createRoute({
  getParentRoute: () => accountDashboardLayoutRoute,
  path: "/datasets",
  component: Datasets,
});
